import { createGlobalStyle } from 'styled-components';
import LatoTTF from '../assets/fonts/Lato/Lato-Regular.ttf';
import LatoWOFF from '../assets/fonts/Lato/Lato-Regular.woff';
import LatoSVG from '../assets/fonts/Lato/Lato-regular.svg';
import LatoEOT from '../assets/fonts/Lato/Lato-regular.eot';

import LatoLightTTF from '../assets/fonts/Lato/Lato-Light.ttf';
import LatoLightWOFF from '../assets/fonts/Lato/Lato-Light.woff';
import LatoLightEOT from '../assets/fonts/Lato/Lato-light.eot';

import LatoMediumTTF from '../assets/fonts/Lato/Lato-Regular.ttf';
import LatoMediumWOFF from '../assets/fonts/Lato/Lato-Regular.woff';
import LatoMediumSVG from '../assets/fonts/Lato/Lato-regular.svg';
import LatoMediumEOT from '../assets/fonts/Lato/Lato-regular.eot';

import LatoSemiBoldTTF from '../assets/fonts/Lato/Lato-Bold.ttf';
import LatoSemiBoldWOFF from '../assets/fonts/Lato/Lato-Bold.woff';
import LatoSemiBoldSVG from '../assets/fonts/Lato/Lato-bold.svg';

import LatoBlackTTF from '../assets/fonts/Lato/Lato-Black.ttf';
import LatoBlackEOT from '../assets/fonts/Lato/Lato-black.eot';
import LatoBlackSVG from '../assets/fonts/Lato/Lato-black.svg';
import LatoBlackWOFF from '../assets/fonts/Lato/Lato-black.woff';

import LatoRegularItalicTTF from '../assets/fonts/Lato/Lato-Italic.ttf';
import LatoRegularItalicWOFF from '../assets/fonts/Lato/Lato-italic.woff';
import Montserrat from '../assets/fonts/Montserrat/Montserrat-VariableFont_wght.ttf';
// import HeaderBg from '../assets/img/headerBg.png';
// import backgroundHistorico from '../assets/img/background-historico.png';
/**
 * Estilos globales de la elección
 */

//  const returnBg = () => {
//   const esHistorico = !!window.location.href.match(/historico/);
//   if(esHistorico){
//     return backgroundHistorico;
//   } else {
//     return HeaderBg;
//   }
//  }

/*const returnBgColor = () => {
  const esEstadisticas = !!window.location.href.match("estadisticas");
  console.log("Es estadisticas ",esEstadisticas);
  if (!esEstadisticas) {
    return 'linear-gradient(to bottom, #f9f9f9 0px, #f9f9f9 355px, #ededed 365px, #fff 366px )';
  } else {
    return '#E5E5E5';
  }
};*/

const FormatoColo19 = createGlobalStyle`
  html {
    font-feature-settings:"lnum" 1;
  }
  @font-face {
    font-family: 'Montserrat';
    src: url(${Montserrat}) format('truetype');
    font-display: fallback;;
  }
  @font-face {
    font-family: 'Lato';
    src: 
      url(${LatoWOFF}) format('woff'),
      url(${LatoTTF}) format('truetype'),
      url(${LatoSVG}) format('svg'),
      url(${LatoEOT}) format('eot');
    font-style: normal;
    font-weight: normal;
    font-display: fallback; /* Para evitar flickering al recargar páginas*/
  }

  @font-face {
    font-family: 'Lato';
    src: 
      url(${LatoLightWOFF}) format('woff'),
      url(${LatoLightTTF}) format('truetype'),
      url(${LatoLightEOT}) format('eot');
    font-style: normal;
    font-weight: 100;
    font-display: fallback; /* Para evitar flickering al recargar páginas*/
  }


  @font-face {
    font-family: 'Lato';
    src: 
      url(${LatoRegularItalicWOFF}) format('woff'),
      url(${LatoRegularItalicTTF}) format('truetype');
    font-style: italic;
    font-weight: normal;
    font-display: fallback; /* Para evitar flickering al recargar páginas*/
  }
  @font-face {
    font-family: 'Lato';
    src: 
      url(${LatoMediumWOFF}) format('woff'),
      url(${LatoMediumTTF}) format('truetype'),
      url(${LatoMediumSVG}) format('svg'),
      url(${LatoMediumEOT}) format('eot');
    font-style: normal;
    font-weight: 500;
    font-display: fallback; /* Para evitar flickering al recargar páginas*/
  }
  @font-face {
    font-family: 'Lato';
    src: 
      url(${LatoSemiBoldWOFF}) format('woff'),
      url(${LatoSemiBoldTTF}) format('truetype'),
      url(${LatoSemiBoldSVG}) format('svg');
    font-style: normal;
    font-weight: 700;
    font-display: fallback; /* Para evitar flickering al recargar páginas*/
  }

  @font-face {
    font-family: 'Lato';
    src: 
      url(${LatoBlackWOFF}) format('woff'),
      url(${LatoBlackTTF}) format('truetype'),
      url(${LatoBlackEOT}) format('eot'),
      url(${LatoBlackSVG}) format('svg');
    font-style: normal;
    font-weight: 900;
    font-display: fallback; /* Para evitar flickering al recargar páginas*/
  }
 

  html, 
  body {
    font-family: 'Montserrat', 'Lato', 'Open Sans', 'Calibri', 'Georgia', 'Helvetica', 'sans-serif';
    color: #222222;
  }

  html {
    @media (min-width: 1025px) {
    }

  }

  body {
    @media (min-width: 768px) {
    }
    background-size: 70% 130px;
    -webkit-print-color-adjust: exact !important;
    color-adjust: exact;
    @media print {
      background: none;
      }
  }

  h1 {
    font-weight: bold;
    font-size: 2.5rem;
  }
  h2 {
    font-size: 1.6rem;
  }
  h3 {
    font-size: 1.2rem;
  }
  h4,
  h5 {
    font-size: 0.9rem;
  }


  /*
    This will hide the focus indicator if the element receives focus via the mouse,
    but it will still show up on keyboard focus.
  */
   .js-focus-visible :focus:not([data-focus-visible-added]) {
    outline: none;
  }

   .js-focus-visible main .focus-visible {
    outline: 2px solid #222222;
    outline-offset: -2px;
  }
   .js-focus-visible footer .focus-visible {
    outline: 2px solid #222222;
    outline-offset: -2px;
  }
   .js-focus-visible header .focus-visible {
    outline: 2px solid white;
    outline-offset: -2px;
  }

    .js-focus-visible a.focus-visible {
    text-decoration: underline !important;
    outline: none !important;
    }


  @keyframes Toastify__trackProgress {
      0% {
        transform: scaleX(1);
      }
      100% {
        transform: scaleX(0);
      }
    }
  .Toastify__progress-bar {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 4px;
    z-index: var(--toastify-z-index);
    opacity: 0.7;
    transform-origin: left;
    background: #215CCC;
  }
  
  .Toastify__progress-bar--default {
    background: #215CCC !important;
  }


  .Toastify__progress-bar--animated {
    animation: Toastify__trackProgress linear 1 forwards;
  }
`;

export default FormatoColo19;
